import { Box } from "@mui/material";
import TkStepper from "../../components/atoms/TkStepper";
import { heirStepper, retireeStepper } from "./parts";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkBorder from "../../components/atoms/TkBorder";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import { httpAPI_RET005 } from "./api/request.formdata";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IAPI_RET005_Request } from "../../type/apiType";
import { BusinessContext } from "../../context/businessContext";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { GlobalContext } from "../../context/globalContext";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { DemanderKbn } from "../../assets/data/Constants";
import { API_RET005_BuildReqParams } from "../../utils/buildRequestParams";

/**
 * SCRR411110 退職手当金の請求手続き（退職所得の申告書の登録）
 * 退職手当金請求者が本人確認書類を登録する。
 * @return SCRR411110
 */
const SCRR411110 = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [activeStep, setActiveStep] = useState<number>(6);
  const demanderKbn = businessState.job_35?.demanderKbn;
  const isRetiree = demanderKbn === DemanderKbn["退職者本人"];
  // 初期表示
  useEffect(() => {
    if (demanderKbn === DemanderKbn["相続人"]) {
      setActiveStep(7);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const makeHttpObj = (): IAPI_RET005_Request => {
    const reqObj: IAPI_RET005_Request = {
      ...businessState.job_35,
      fileList: businessState.job_35?.fileList ?? [],
      tempSaveStep:
        businessState.job_35?.demanderKbn === DemanderKbn["退職者本人"] ? 6 : 7, // 一時保存ステップ
      businessType: businessState.common?.businessType,
      contractorNo:
        state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO
          ? businessState.common?.contractorNo
          : state.authInfo?.contractorNo, // 共済契約者番号
      nowZipcode: isRetiree
        ? businessState.job_35?.demanderZipcode
        : businessState.job_35?.retirementZipcode,
      nowPrefectureCd: isRetiree
        ? businessState.job_35?.demanderPrefectureCd
        : businessState.job_35?.retirementPrefectureCd,
      nowAddressCity: isRetiree
        ? businessState.job_35?.demanderCity
        : businessState.job_35?.retirementAddressCity,
      nowAddressOthers: isRetiree
        ? businessState.job_35?.demanderAddressOthers
        : businessState.job_35?.retirementAddressOthers,
      screenId: "SCRR411110",
    };

    return API_RET005_BuildReqParams(reqObj);
  };

  const handleSubmit = async (index: any) => {
    switch (index) {
      case 0: // 一時保存
        // 退職手当金請求更新API実行
        try {
          const res = await httpAPI_RET005({
            ...makeHttpObj(),
          });

          if (res.resultCd === "I0000") {
            setState({
              ...state,
              errorMsgId: "",
            });

            setBusinessState({
              ...businessState,
              job_35: {
                ...businessState.job_35,
                tempSaveStep:
                  businessState.job_35?.demanderKbn ===
                  DemanderKbn["退職者本人"]
                    ? 6
                    : 7,
                applyId: res.applyId,
              },
            });
            setOpen(true);
          } else {
            setState({
              ...state,
              errorMsgId: res.resultCd,
            });
          }
        } catch (error) {
          navigate("/error");
        }
        break;

      case 1: // 次へ
        navigate("/SCRR411111");
        break;
    }
  };

  return (
    <Box data-testid="SCRR411110test">
      <TkStepper
        steps={
          demanderKbn === DemanderKbn["相続人"] ? heirStepper : retireeStepper
        }
        activeStep={activeStep - 1}
        savaStep={businessState.job_35?.tempSaveStep!}
      />

      <TkInfoManual rule="\n">{labelids.labelid.LBLR411110_01}</TkInfoManual>

      {state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO && (
        <TkContractorAndNumberLine
          name="退職者名"
          no={businessState.job_35?.staffNameKanji!}
        />
      )}

      <TkBorder>
        <TkInfoManual rule="\n">{labelids.labelid.LBLR411110_02}</TkInfoManual>
      </TkBorder>

      <TkFakeTable
        list={[]}
        submitButtonGroup={[
          { submitButtonText: "一時保存" },
          { submitButtonText: "次へ" },
        ]}
        buttonGroup={<TkBackButton />}
        onCheckAndSubmit={(_e, index) => handleSubmit(index)}
      />

      <TkMessageDialog
        open={open}
        onOky={() => setOpen(false)}
        title="一時保存完了"
        contextText="　一時保存が完了しました。"
        okText="はい"
        cancelText=""
      />
    </Box>
  );
};

export default SCRR411110;
